import React from 'react';
import ContactSubheading from '../contact-subheading';

const parseQuery = (url) => {
  let parts = [];
  for (const [key, value] of url.searchParams) {
    parts = [...parts, { key, value }];
  }
  return parts;
}

const buildPath = (path, newQuery) => { 
  return path + '?' + newQuery.map(p => `${p.key}=${encodeURIComponent(p.value)}`).join("&");
}

const parseUnitUrl = (url) => { 
  if (url) { 
    var specificUrl = 'https://1177.se' + url;
    return isUrlValid(specificUrl) ? new URL(specificUrl) : null;
  }
  return null;
}

const rewriteQuery = (originalQuery, queryPair) => { 
  let newQuery = originalQuery.filter(k => k.key !== queryPair.key);
  return [...newQuery, queryPair];
}

const rewriteUrl = (referrerUrl, href) => { 
  const parsedUnit = parseUnitUrl(href);
  if (parsedUnit) {
    const originalQuery = parseQuery(referrerUrl);
    const unitsQuery = parseQuery(parsedUnit);
    
    const careType = unitsQuery.find(k => k.key === "caretype");
    if (careType) {
      let newQuery = rewriteQuery(originalQuery, careType);
      newQuery = rewriteQuery(newQuery, { key: "q", value: "" });
      return buildPath(parsedUnit.pathname, newQuery);
    }
   }
  return href;
}

const validateReferrer = (referrerUrl, unitUrl) => { 
  return referrerUrl && referrerUrl.host && referrerUrl.host.includes("1177") && referrerUrl.pathname && referrerUrl.pathname.includes(unitUrl.pathname);
}

const rewriteUrls = (items) => { 
  if (typeof URL === 'undefined') return items;
  if (items && items.length > 0) {
    const referrerUrl = isUrlValid(document.referrer) ? new URL(document.referrer) : null;
    
    const firstUnitUrl = parseUnitUrl(items[0].Url);
    if (firstUnitUrl && validateReferrer(referrerUrl, firstUnitUrl)) { 
      return items.map(item => ({ ...item, Url: rewriteUrl(referrerUrl, item.Url) }));
    }
  }
  return items;
}

const isUrlValid = (url) => { 
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
}

const UnitsLike = (props) => {
  const { items, Translations } = props;

  const redirectItems = rewriteUrls(items);

  return (
    <div className="units-like">
      <ContactSubheading Heading={Translations.moreunitslike} />
      <ul className="units-like__list">
        {redirectItems.map((item, index) => (
          <li key={index}>
            {item.Url && item.Text && (
              <a className="units-like__list-item" href={item.Url}>
                {item.Text}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UnitsLike;
